import type { FC } from 'react';
import { KycIdvDialog } from '@pflegenavi/web-components';
import {
  useCreateIdvSession,
  useGetIdvSession,
  useGetServiceProviderPhoenix,
  useRetryIdvPsc,
} from '@pflegenavi/service-provider-frontend/api';

/** Dialog subject for `useKycIdvDialogState`; a provider only has its own KYC. */
export const SERVICE_PROVIDER_KYC_SUBJECT = 'service-provider';

interface ServiceProviderKycIdvDialogProps {
  open: boolean;
  onClose: () => void;
  returnUrl: string;
}

export const ServiceProviderKycIdvDialog: FC<
  ServiceProviderKycIdvDialogProps
> = ({ open, onClose, returnUrl }) => {
  const { data: serviceProvider } = useGetServiceProviderPhoenix();
  const sessionStatus =
    serviceProvider?.data.mangopay_idv_session_status ?? null;
  const { data: session, isPending: sessionLoading } = useGetIdvSession({
    enabled: open && sessionStatus !== null,
  });
  const { mutateAsync: createIdvSession } = useCreateIdvSession();
  const { mutateAsync: retryIdvPsc } = useRetryIdvPsc();

  return (
    <KycIdvDialog
      open={open}
      onClose={onClose}
      subject="service-provider"
      kycVerified={serviceProvider?.data.mangopay_kyc_verified ?? false}
      renewalDeadline={serviceProvider?.data.kyc_renewal_deadline ?? null}
      lastKycDate={serviceProvider?.data.last_kyc_date ?? null}
      sessionStatus={sessionStatus}
      session={session}
      sessionLoading={sessionLoading}
      returnUrl={returnUrl}
      onStartSession={createIdvSession}
      onRetryPsc={retryIdvPsc}
    />
  );
};
